import { render, staticRenderFns } from "./pure-text.vue?vue&type=template&id=f8b7f6ac&scoped=true&"
import script from "./pure-text.vue?vue&type=script&lang=ts&"
export * from "./pure-text.vue?vue&type=script&lang=ts&"
import style0 from "./pure-text.vue?vue&type=style&index=0&id=f8b7f6ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b7f6ac",
  null
  
)

export default component.exports